<template>
  <div
    class="base-title">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "DefaultTitle",

  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
title {
  font-size: 1.25rem;
  color: var(--v-primary-base) !important;
  letter-spacing: 0px;
  font: normal normal bold 20px/27px;
}
</style>